import {TimeINTimeOUTTypes} from '../ActionTypes/TimeINTimeOUTTypes';

class TimeINTimeOUTActions {

  static setTimeIN = payload => {
    return {
      type: TimeINTimeOUTTypes.TIME_IN,
      payload: payload,
    };
  };

  static setTimeOUT = payload => {
    return {
      type: TimeINTimeOUTTypes.TIME_OUT,
      payload: payload,
    };
  };

  static setWorkIN = payload => {
    return {
      type: TimeINTimeOUTTypes.WORK_TIME_IN,
      payload: payload,
    };
  };

  static setWorkOUT = payload => {
    return {
      type: TimeINTimeOUTTypes.WORK_TIME_OUT,
      payload: payload,
    };
  };

  static setBreakIN = payload => {
    return {
      type: TimeINTimeOUTTypes.BREAK_TIME_IN,
      payload: payload,
    };
  };

  static setBreakOUT = payload => {
    return {
      type: TimeINTimeOUTTypes.WORK_TIME_OUT,
      payload: payload,
    };
  };

  static setPlay = payload => {
    return {
      type: TimeINTimeOUTTypes.PLAY,
      payload: payload,
    };
  };

  static setBreak = payload => {
    return {
      type: TimeINTimeOUTTypes.BREAK,
      payload: payload,
    };
  };

  static setBreakStartTime = payload => {
    return {
      type: TimeINTimeOUTTypes.BREAK_IN,
      payload: payload,
    };
  };

  static setBreakEndTime = payload => {
    return {
      type: TimeINTimeOUTTypes.BREAK_OUT,
      payload: payload,
    };
  };

  static setDataMessage = payload => {
    return {
      type: TimeINTimeOUTTypes.DATA_MESSAGE,
      payload: payload,
    };
  };

  static setTimeInImage = payload => {
    return {
      type: TimeINTimeOUTTypes.TIME_IN_IMAGE,
      payload: payload,
    };
  };

  static setLunchAfterImage = payload => {
    return {
      type: TimeINTimeOUTTypes.LUNCH_AFTER_IMAGE,
      payload: payload,
    };
  };
}

export default TimeINTimeOUTActions;
